/* Prepare below-DI product details without waiting for the theme's deferred scripts. */
(() => {
  if (window.SissiluxDetailImages) {
    window.SissiluxDetailImages.init(document);
    return;
  }
  const observers = new Map();
  const imageSelector = '.image-with-text__media > img';
  const prepare = image => {
    image.fetchPriority = 'low';
    image.loading = 'eager';
  };
  function init(scope) {
    const connection = navigator.connection;
    if (connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) return;
    scope.querySelectorAll('[data-sissilux-detail-images]').forEach(root => {
      if (observers.has(root) || !root.getClientRects().length) return;
      let previous = root.closest('.shopify-section')?.previousElementSibling;
      let di;
      while (previous && !di) {
        di = previous.querySelector('[data-sdi-root]');
        previous = previous.previousElementSibling;
      }
      if (!di) return;
      const images = [...root.querySelectorAll(imageSelector)];
      if (!images.length) return;
      prepare(images[0]);
      // The initial image can be downloading while the visitor reads the purchase area.
      // Remaining images wait for the DI to enter view, leaving the hero priority intact.
      observers.set(root, null);
      if (!('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        images.slice(1).forEach(prepare);
        observer.disconnect();
        observers.set(root, null);
      });
      observers.set(root, observer);
      observer.observe(di);
    });
  }
  function unload(event) {
    for (const [root, observer] of observers) {
      if (event.target.contains(root)) {
        observer?.disconnect();
        observers.delete(root);
      }
    }
  }
  window.SissiluxDetailImages = { init };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', unload);
})();
